import { render } from "./LiveStockList.vue?vue&type=template&id=79e2b9a9"
import script from "./LiveStockList.vue?vue&type=script&lang=js"
export * from "./LiveStockList.vue?vue&type=script&lang=js"
script.render = render

export default script